export default () => ({
  tutorialSteps: [
    [1, 2],
    [3, 2],
    [4, 1],
    [0, 3],
  ],
  title: '#02',
  mapStr: `
    ----b
    -r-pb
    pr-rp
    bp-r-
    b----
  `
})



// WEBPACK FOOTER //
// ./src/levels/tutorial-2.js